export const CutPrices = {
  BASIC_CUT: "11",
  BEARD: "11",
  EXCLUSIVE_CUT: "14",
  BASIC_BEARD: "21",
  EXCLUSIVE_BEARD: "24"
};
